// libs
import React from 'react';
import PropTypes from 'prop-types';

// Props and Context
const propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
const defaultProps = {
  subtitle: '',
};

function SingleTitle({ title, subtitle }) {
  return (
    <div className="single__title single__columns__content">
      <div className="lined-title">
        <h1 className="lined-title__title">{title}</h1>
        {subtitle &&
          <h2 className="lined-title__subtitle">{subtitle}</h2>
        }
      </div>
    </div>
  );
}

SingleTitle.propTypes = propTypes;
SingleTitle.defaultProps = defaultProps;

export default SingleTitle;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/SingleTitle.js